import styles from './PlacingOrderAddressDropdownItem.module.scss';
import DelIcon from '@assets/icons/outline/trash-2.svg?react';
import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import { IPlacingOrderAddressDropdownItemProps } from '../../placing-types';

const PlacingOrderAddressDropdownItem: React.FC<IPlacingOrderAddressDropdownItemProps> = (props: IPlacingOrderAddressDropdownItemProps): React.ReactElement => {
  const { item, handlerGetFullAddress, handlerOnClickDeleteAddress, onClose } = props;

  return (
      <div className={styles.address}>
        {handlerGetFullAddress(item, 'renderItem')}
        {!!item.id.length && (
          <IconButton
            size={IconButtonSize.S}
            type={IconButtonType.ICON}
            icon={DelIcon}
            onClick={(e: any) => {
              e.stopPropagation();
              handlerOnClickDeleteAddress(item.id);
              onClose && onClose();
            }}
          />
        )}
      </div>
  );
};

export default PlacingOrderAddressDropdownItem;
